import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rows", "template"]

  connect() {
    this.nextIndex = this.rowsTarget.children.length
    this.rowsTarget.querySelectorAll('input[name$="[_destroy]"]').forEach((input) => this.syncDeletedRow(input))
  }

  add() {
    const index = `nova_${this.nextIndex++}`
    this.rowsTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML.replaceAll("__INDEX__", index))
    this.rowsTarget.lastElementChild?.querySelector("select")?.focus()
  }

  toggleDelete(event) {
    this.syncDeletedRow(event.currentTarget)
  }

  syncDeletedRow(input) {
    input.closest("tr")?.classList.toggle("table-danger", input.checked)
  }

  confirmDelete(event) {
    const count = [...this.rowsTarget.querySelectorAll('input[name$="[_destroy]"]:checked')]
      .filter((input) => input.closest("tr")?.querySelector('input[name$="[id]"]')).length
    if (count > 0 && !window.confirm(`Excluir ${count} carga(s) marcada(s) e seus ingressos?`)) {
      event.preventDefault()
    }
  }
}
